import { ArrowDownIcon } from '@blueprinthq/joy'
import {
  Box,
  Button,
  Flex,
  HStack,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Portal,
  Text,
  VStack
} from '@chakra-ui/react'
import React from 'react'
import { DailyCompactAudioLevel } from '../components'

export const AVDeviceSelector = ({
  type,
  icon,
  devices,
  selectedDeviceId,
  onDeviceChange,
  isBlocked
}: {
  type: 'microphone' | 'speaker' | 'camera'
  icon: any
  devices: any[]
  selectedDeviceId: string
  onDeviceChange: (device: any) => void
  isBlocked?: boolean
}) => {
  return (
    <VStack spacing={4} textAlign="left" w="100%">
      <Box w="100%">
        <Menu id={`${type}-selector-menu`} matchWidth>
          <MenuButton
            isDisabled={isBlocked}
            border={`1px solid #e4e5e6`}
            m="0"
            w="100%"
            h="40px"
            bg="white"
            borderRadius="8px"
            as={Button}
            rightIcon={<ArrowDownIcon />}
            data-click-text={`Select ${type}`}
          >
            <Flex w="100%" alignItems="center" justifyContent="space-between">
              <HStack spacing={3} minWidth="0" flex="1">
                <Flex
                  w="24px"
                  h="24px"
                  align="center"
                  justify="center"
                  flexShrink={0}
                >
                  {icon}
                </Flex>
                <Text
                  color={isBlocked ? 'error' : 'black'}
                  overflow="hidden"
                  textOverflow="ellipsis"
                  whiteSpace="nowrap"
                  minWidth="0"
                >
                  {!devices.length
                    ? `No ${type} inputs detected`
                    : devices.find(
                        device => device.device.deviceId === selectedDeviceId
                      )?.device.label || devices[0].device.label}
                </Text>
              </HStack>
              {type === 'microphone' && <DailyCompactAudioLevel />}
            </Flex>
          </MenuButton>
          <Portal>
            <MenuList w="100%" minWidth="unset" style={{ width: 'inherit' }}>
              {devices.map(input => (
                <MenuItem
                  isDisabled={input.device.deviceId === selectedDeviceId}
                  h="48px"
                  w="100%"
                  key={input.device.deviceId}
                  onClick={onDeviceChange}
                  value={input.device.deviceId}
                  color="black"
                  maxWidth="100%"
                  icon={
                    input.device.deviceId === selectedDeviceId ? (
                      icon
                    ) : (
                      <Box w="large" mr="medium" />
                    )
                  }
                >
                  {input.device.label}
                </MenuItem>
              ))}
            </MenuList>
          </Portal>
        </Menu>
        {isBlocked && (
          <Text color="error" fontSize="12px" mt="xxsmall">
            {`Go to your browser settings to enable ${type}`}
          </Text>
        )}
      </Box>
    </VStack>
  )
}
